import { render, staticRenderFns } from "./home.vue?vue&type=template&id=387abf2a&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=387abf2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387abf2a",
  null
  
)

export default component.exports